import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "src/app/core/services/api.service";
import { AuthService } from "src/app/core/endpoints/auth.service";

@Component({
	selector: "app-conditions-general",
	templateUrl: "./conditions-general.component.html",
	styleUrls: ["./conditions-general.component.scss"],
})
export class ConditionsGeneralComponent implements OnInit {
	public loading = false;
	public forgotten = false;
	public register = false;
	versionApp:any = "";

	constructor(
		private router: Router,
		private apiService: ApiService,
	) {
		this.loadVersion();
	}

	ngOnInit(): void {
	}
	loadVersion(){
		this.apiService.getEntity('version').subscribe({
		  next: (response) => {
			this.versionApp = response;
			localStorage.setItem('versionApp',this.versionApp);
		  }
		});
	}
}
